import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout,
  props: {
    tenantList: {
      type: Array,
      "default": []
    }
  },
  data: function data() {
    return {
      tenant: '',
      errorMsg: '',
      isLoadingCrmConfig: false,
      crmConfig: {}
    };
  },
  methods: {
    getTenantCrmConfig: function getTenantCrmConfig() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.crmConfig = {};
                if (!(_this.tenant.length == 0)) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _this.isLoadingCrmConfig = true;
                _context.next = 6;
                return axios.post('/crm/config', {
                  tenantId: _this.tenant,
                  crmType: 'HUBSPOT'
                });
              case 6:
                res = _context.sent;
                if (res.data.status == 'success') {
                  _this.crmConfig = res.data.crmConfig;
                }
                _this.isLoadingCrmConfig = false;
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    saveConfig: function saveConfig() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.errorMsg = '';
                if (_this2.crmConfig.access_token) {
                  _context2.next = 4;
                  break;
                }
                _this2.errorMsg = 'Please enter the access token.';
                return _context2.abrupt("return", true);
              case 4:
                if (!(_this2.crmConfig.sync.length == 0)) {
                  _context2.next = 7;
                  break;
                }
                _this2.errorMsg = 'Please select a sync type.';
                return _context2.abrupt("return", true);
              case 7:
                _this2.isLoadingCrmConfig = true;
                _context2.next = 10;
                return axios.post('/crm/store', _this2.crmConfig);
              case 10:
                res = _context2.sent;
                _this2.$store.loading = false;
                ElMessage({
                  showClose: true,
                  message: res.data.message,
                  type: res.data.status
                });
                _this2.getTenantCrmConfig();
              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};